import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHead, Reveal } from "./Reveal";
import { useContent } from "@/context/ContentContext";

export default function Faq() {
  const c = useContent();
  const items = (c.faq || []).filter((f) => f.active !== false);
  if (!items.length) return null;

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32 bg-[#0C0C0E] border-t border-white/5">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <SectionHead
          eyebrow={c.texts.faq_eyebrow}
          title={c.texts.faq_title}
          sub={c.texts.faq_sub}
          align="center"
        />
        <Reveal delay={0.1} className="mt-12">
          <Accordion type="single" collapsible className="w-full">
            {items.map((f, i) => (
              <AccordionItem key={f.id} value={`item-${i}`} data-testid="faq-accordion-item" className="border-zinc-800/80">
                <AccordionTrigger className="text-left text-base sm:text-lg font-semibold text-zinc-100 hover:text-blue-400 hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm sm:text-base text-zinc-300 leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
